<template>
  <div class="assets" >
    <s-table
      class="assets__table no-align"
      :fields="fields"
      :items="assets"
      :busy="loading"
    >
      <template #head(check)>
        <div class="assets__check-wrapper">
          <b-form-checkbox
            :checked="allSelected"
            @change="toggleAll"
            @click.native.stop
          />
        </div>
      </template>
      <template #cell(check)="data">
        <b-form-checkbox v-model="data.item.selected" />
      </template>
    </s-table>
  </div>
</template>

<script>
import { uniqBy } from 'lodash';
import ProfileEditService from '@/domain/services/generalPanel/adminPanel/profile/profileEditService';

export default {
  name: 'Assets',
  props: {
    profile: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    loading: true,
    assets: [],
  }),
  computed: {
    allSelected() {
      return this.assets.length > 0 && this.assets.every(it => it.selected);
    },
    fields() {
      return [
        { key: 'check', class: 'assets__cell-check' },
        {
          key: 'name',
          label: this.$t('profile-manager.editing.assets.name'),
          class: 'assets__cell-name',
        },
        {
          key: 'assetTypeName',
          label: this.$t('profile-manager.editing.assets.type'),
          class: 'assets__cell-asset-type',
        },
        {
          key: 'installationName',
          label: this.$t('profile-manager.editing.assets.installation'),
          class: 'assets__cell-installation-name',
        },
      ];
    },
    installationsIds() {
      return (this.profile.installations || []).map(it => it.id);
    },
    selection() {
      return this.assets.filter(it => it.selected);
    },
  },
  created() {
    this.getProfileAssets();
  },
  methods: {
    handleAssetsSelection() {
      if (!this.profile.assets) return;
      this.profile.assets.forEach(({ id: assetId }) => {
        const asset = this.assets.find(it => it.id === assetId);
        if (asset) {
          asset.selected = true;
        }
      });
    },
    toggleAll(checked) {
      this.assets.forEach((it) => {
        it.selected = checked;
      });
    },
    getProfileAssets() {
      ProfileEditService.getProfileAssets({
        profileId: this.profile.id,
        parentProfileId: this.profile.parentProfileId,
        installationsIds: this.installationsIds,
      }).then((data) => {
        this.loading = false;
        this.assets = data;
        this.handleAssetsSelection();
        this.setInitialValues();
      }).finally(() => {
        this.loading = false;
      });
    },
    setInitialValues() {
      this.$emit('setInitialValues:assets', this.assets.filter(asset => asset.selected));
    },
  },
  watch: {
    selection(items) {
      if (!this.loading) {
        const preservedItems = this.profile.assets.filter(oldItem => !this.assets
          .some(currentItem => currentItem.id === oldItem.id));
        this.profile.assets = uniqBy([...preservedItems, ...items], 'id');
      }
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "src/styles/defaults/variables"
  @import "src/styles/defaults/mobile-first"

  .assets
    &__table ::v-deep
      max-height: 430px
    &__loader
      font-size: 2em
      margin-bottom: 1em
    &__check-wrapper
      display: flex
    ::v-deep &__cell
      &-check
        width: 40px
      &-name,
      &-asset-type,
      &-installation-name
        text-align: center
    +media-min-sm()
      &__table ::v-deep
        max-height: initial
        tbody
          display: block
          max-height: 430px
          overflow: auto
        tbody, thead
          tr
            display: table
            width: 100%
            table-layout: fixed
    +media-min-md()
    +media-min-lg()
</style>
